import axios from 'axios';

const API_HOST = process.env.REACT_APP_API_HOST;

async function createRota(schedule: any) {
  const response = await axios.post(`${API_HOST}/v1/rota/schedule`, schedule);
  return response;
}

async function getRotaSchedule(date: string | Date) {
  const { data } = await axios.get(`${API_HOST}/v1/rota/schedule/${date}`);
  return data;
}

/** Publishes a schedule: assigned employees are notified and can see it. */
async function publishSchedule(id: string) {
  const { data } = await axios.post(
    `${API_HOST}/v1/rota/schedule/${encodeURIComponent(id)}/publish`,
  );
  return data;
}

export type MyShift = {
  id: string;
  name: string;
  start_date: string;
  end_date: string;
  start_time: string;
  end_time: string;
  color?: string;
};

/** The signed-in employee's published shifts between two dates. */
async function getMySchedules(from: string, to: string): Promise<MyShift[]> {
  const { data } = await axios.get(`${API_HOST}/v1/rota/my-schedules`, {
    params: { from, to },
  });
  return Array.isArray(data?.data) ? data.data : [];
}

const rota = {
  createRota,
  getRotaSchedule,
  publishSchedule,
  getMySchedules,
};

export default rota;
